export function appraisedValueObjectionNotice2027() {
return [   // Release 2026-10-02 08:10:09
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 254.76,
   left: 403.32,
   width: 169.20,
   height: 9.60
}
,
{
   page: 0,
   name: "Date Contract Date", 
   fontSize: 9,
   type: "date",
   top: 280.2,
   left: 379.32,
   width: 126.24,
   height: 9.6
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 309.12,
   left: 47.76,
   width: 430.80,
   height: 9.60
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 296.04,
   left: 47.64,
   width: 461.16,
   height: 9.60
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 324.96,
   left: 282.96,
   width: 289.56,
   height: 9.60
}
,
{
   page: 0,
   name: "Checkbox Appraisal is attached", 
   isText: false,
   type: "checkbox",
   top: 420.875,
   left: 193.092,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Appraisal is not attached", 
   isText: false,
   type: "checkbox",
   top: 420.875,
   left: 220.492,
   width: 10.735,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Lender verification is attached", 
   isText: false,
   type: "checkbox",
   top: 437.238,
   left: 242.183,
   width: 10.080,
   height: 10.080
}
,
{
   page: 0,
   name: "Checkbox Lender verification is not attached", 
   isText: false,
   type: "checkbox",
   top: 437.238,
   left: 270.328,
   width: 10.080,
   height: 10.080
}
] }
